import { render, staticRenderFns } from "./ArchivedConversation.vue?vue&type=template&id=f0f7847e"
import script from "./ArchivedConversation.vue?vue&type=script&lang=js"
export * from "./ArchivedConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports